import { addPlayerEnterChatItem, addPlayerLeaveChatItem } from './chatActions';
import { setPlayerServerSettingsFromInbound, thunkSetSelfDataFromInbound } from './selfDataActions';
import { thunkEndTransitionAnimation } from './transitionAnimationActions';
export const CLEAR_MTT_STAGING_SCENE = 'CLEAR_MTT_STAGING_SCENE';
export const INIT_MTT_STAGING_FROM_INBOUND = 'INIT_MTT_STAGING_FROM_INBOUND';
export const ENTER_MTT_STAGING_PLAYER_FROM_INBOUND = 'ENTER_MTT_STAGING_PLAYER_FROM_INBOUND';
export const LEAVE_MTT_STAGING_PLAYER_FROM_INBOUND = 'LEAVE_MTT_STAGING_PLAYER_FROM_INBOUND';
export const UPDATE_MTT_STAGING_PLAYER_READY_STATE_FROM_INBOUND = 'UPDATE_MTT_STAGING_PLAYER_READY_STATE_FROM_INBOUND';
export const BECOME_MTT_OWNER = 'BECOME_MTT_OWNER';
export const UPDATE_MTT_STAGING_INFO_FROM_INBOUND = 'UPDATE_MTT_STAGING_INFO_FROM_INBOUND';
export const SET_MTT_STAGING_TABLES_FROM_INBOUND = 'SET_MTT_STAGING_TABLES_FROM_INBOUND';
export const UPDATE_MTT_STAGING_TABLE_FROM_INBOUND = 'UPDATE_MTT_STAGING_TABLE_FROM_INBOUND';
export const SET_MY_PLAYER_ID = 'SET_MY_PLAYER_ID';
export const SET_MTT_STAGING_PLAYER_BANK = 'SET_MTT_STAGING_PLAYER_BANK_FROM_INBOUND';
export const UPDATE_MTT_STAGING_PLAYERS_FROM_INBOUND = 'UPDATE_MTT_STAGING_PLAYERS_FROM_INBOUND';
export const RENAME_MTT_STAGING_ROOM = 'RENAME_MTT_STAGING_ROOM';
export const SHOW_MTT_STAGING_PRIZE_WIN_FROM_INBOUND = 'SHOW_MTT_STAGING_PRIZE_WIN_FROM_INBOUND';
export const HIDE_MTT_STAGING_PRIZE_WIN = 'HIDE_MTT_STAGING_PRIZE_WIN';
export function clearMttStagingState() {
    return {
        type: CLEAR_MTT_STAGING_SCENE
    };
}
function initMttStagingFromInbound(inbound) {
    return {
        type: INIT_MTT_STAGING_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkInitMttStagingFromInbound = (inbound) => {
    return function (dispatch) {
        dispatch(setPlayerServerSettingsFromInbound(inbound.inboundPlayerServerSettings));
        dispatch(thunkSetSelfDataFromInbound(inbound.inboundSelfData));
        dispatch(initMttStagingFromInbound(inbound));
        dispatch(thunkEndTransitionAnimation());
    };
};
function enterMttStagingPlayerFromInbound(inbound) {
    return {
        type: ENTER_MTT_STAGING_PLAYER_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkEnterMttStagingPlayerFromInbound(inbound) {
    return function (dispatch) {
        dispatch(addPlayerEnterChatItem(inbound.enterMessage));
        dispatch(enterMttStagingPlayerFromInbound(inbound));
    };
}
function leaveMttStagingPlayerFromInbound(inbound) {
    return {
        type: LEAVE_MTT_STAGING_PLAYER_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkLeaveMttStagingPlayerFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        const existingInitializedPlayer = state.mttStaging.players.find((player) => player.id === inbound.playerId && player.isClientLoadDone);
        if (existingInitializedPlayer) {
            const leaveMessage = `${existingInitializedPlayer.name} ${inbound.isLoggingOut ? 'logged out' : 'left'}.`;
            dispatch(addPlayerLeaveChatItem(leaveMessage));
        }
        dispatch(leaveMttStagingPlayerFromInbound(inbound));
    };
}
export function updateMttStagingPlayerReadyStateFromInbound(inbound) {
    return {
        type: UPDATE_MTT_STAGING_PLAYER_READY_STATE_FROM_INBOUND,
        payload: inbound
    };
}
export function becomeMttOwner() {
    return {
        type: BECOME_MTT_OWNER
    };
}
export function updateMttStagingInfoFromInbound(inbound) {
    return {
        type: UPDATE_MTT_STAGING_INFO_FROM_INBOUND,
        payload: inbound
    };
}
export function setMttStagingTablesFromInbound(inbound) {
    return {
        type: SET_MTT_STAGING_TABLES_FROM_INBOUND,
        payload: inbound
    };
}
export function updateMttStagingTableFromInbound(inbound) {
    return {
        type: UPDATE_MTT_STAGING_TABLE_FROM_INBOUND,
        payload: inbound
    };
}
export function setMyPlayerIdInMttStaging(playerId) {
    return {
        type: SET_MY_PLAYER_ID,
        payload: playerId
    };
}
export function setMttStagingPlayerBank({ playerId, numChipsInBank, mttStartingChips }) {
    return {
        type: SET_MTT_STAGING_PLAYER_BANK,
        payload: { playerId, numChipsInBank, mttStartingChips }
    };
}
export function updateMttStagingPlayersFromInbound(inbound) {
    return {
        type: UPDATE_MTT_STAGING_PLAYERS_FROM_INBOUND,
        payload: inbound
    };
}
export function renameMttStagingRoom(newName) {
    return {
        type: RENAME_MTT_STAGING_ROOM,
        payload: newName
    };
}
export function showMttStagingPrizeWinFromInbound(inbound) {
    return { type: SHOW_MTT_STAGING_PRIZE_WIN_FROM_INBOUND, payload: inbound };
}
export function hideMttStagingPrizeWin() {
    return { type: HIDE_MTT_STAGING_PRIZE_WIN };
}
